
import { chartConfigs as lifeCycleCharts, overviewTiles as lifeCycleTiles } from '../views/DashboardView/configs/LC.DashboardConfig';
import { detailsTableColumns as lifeCycleColumns } from "../components/DetailsTable/configs/LC.DetailsTableConfig";

/**
 * Configuration object for a service.
 * 
 * @typedef {Object} ServiceConfig
 * @property {string} id - Unique identifier for the service (e.g., 'lifecycle', 'realtalk').
 * @property {string} code - Short code for the service.
 * @property {string} displayName - Human-readable name of the service (e.g., 'Lifecycle Teams', 'RealTalk Chats').
 * @property {string} apiBaseUrl - Base URL or endpoint prefix for the service API.
 * @property {any[]} detailsTable - Configuration array of columns to pass to DetailsTable.
 * @property {any[]} chartsConfig - Configuration array of columns to pass to DetailsTable.
 * @property {any[]} tilesConfig - Configuration array of columns to pass to DetailsTable.
 */
export interface ServiceConfig {
  id: string;
  code: string;
  displayName: string;
  apiBaseUrl: string;
  detailsTableConfig: any[];
  chartsConfig: any[];
  tilesConfig: any[];
}

if (!process.env.REACT_APP_LIFECYCLE_API) {
  console.warn("Missing REACT_APP_LIFECYCLE_API in .env");
}

export const servicesConfig: Record<string, ServiceConfig> = {
  lifecycle: {
    id: "lifecycle",
    code: "LC",
    displayName: "Lifecycle Teams",
    apiBaseUrl: process.env.REACT_APP_LIFECYCLE_API || "",
    detailsTableConfig: lifeCycleColumns,
    chartsConfig: lifeCycleCharts,
    tilesConfig: lifeCycleTiles,
  },
//  realidentiy: {
//     id: "realidentiy",
//     code: "RI",
//     displayName: "Real Identity",
//     apiBaseUrl: process.env.REACT_APP_LIFECYCLE_API || "",
//     detailsTableConfig: lifeCycleColumns,
//     chartsConfig: lifeCycleCharts,
//     tilesConfig: lifeCycleTiles,
//   },
};

export const CURRENT_SERVICE_CODE = "LC";